exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._2pPmRDCtOCALDtcfrLJsa1{padding:20px;background:\"[theme:white, default:#ffffff]\"}", ""]);
// Exports
exports.locals = {
	"spinner": "_2pPmRDCtOCALDtcfrLJsa1"
};